import { render, staticRenderFns } from "./backPrivilegeManage.vue?vue&type=template&id=1362a38d&scoped=true"
import script from "./backPrivilegeManage.vue?vue&type=script&lang=js"
export * from "./backPrivilegeManage.vue?vue&type=script&lang=js"
import style0 from "./backPrivilegeManage.vue?vue&type=style&index=0&id=1362a38d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1362a38d",
  null
  
)

export default component.exports